import {ChangeDetectionStrategy, Component, computed, inject, input, output} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {PageEvent} from '@angular/material/paginator';
import {Sort} from '@angular/material/sort';
import {TranslateService} from '@ngx-translate/core';
import {NgxAurMatTableModule} from 'ngx-aur-mat-table';

import {DriverHistory} from '@common-module/modelinterfaces/driver-history.model';
import {DriverAction} from '@common-module/modelinterfaces/enums/driver-action';
import {ServerTablePaginationTableState} from '@common-module/table-config/server-table-pagination';

import {createDriverHistoryTableConfig} from './driver-history-table.config';

@Component({
  selector: 'app-driver-history-table',
  imports: [MatIconModule, NgxAurMatTableModule],
  templateUrl: './driver-history-table.component.html',
  styleUrl: './driver-history-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriverHistoryTableComponent {
  public readonly history = input.required<DriverHistory[]>();
  public readonly pagination = input.required<ServerTablePaginationTableState>();
  public readonly timeZone = input.required<string>();
  public readonly pageChange = output<PageEvent>();
  public readonly sortChange = output<Sort>();

  private readonly translateService = inject(TranslateService);

  protected readonly tableConfig = computed(() =>
    createDriverHistoryTableConfig(
      key => this.translateService.instant(key),
      this.timeZone(),
      this.pagination(),
    ),
  );

  protected actionIcon(history: DriverHistory): string {
    return history.action === DriverAction.TAKE ? 'insert_link' : 'link_off';
  }
}
